/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import '../styles/Login.css';

const OAuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // Get token and user data from URL
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');

    if (token) {
      localStorage.setItem('token', token);
    }

    if (userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        localStorage.setItem('user', JSON.stringify(user));
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }

    // Countdown and redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [searchParams, navigate]);

  return (
    <div className="login-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="login-box" style={{ textAlign: 'center', maxWidth: '500px' }}>
        <FontAwesomeIcon
          icon={faCheckCircle}
          style={{ fontSize: '64px', color: '#10b981', marginBottom: '20px' }}
        />
        <h2 style={{ color: '#10b981', marginBottom: '10px' }}>Login Successful!</h2>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          You have successfully signed in with Google.
        </p>
        <p style={{ color: '#999', fontSize: '14px' }}>
          Redirecting to your dashboard in {countdown} second{countdown !== 1 ? 's' : ''}...
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            marginTop: '20px',
            padding: '12px 24px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Go to Dashboard Now
        </button>
      </div>
    </div>
  );
};

export default OAuthSuccess;
